import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';

const Register = () => {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!name || !email || !password || !confirmPassword) {
      toast.error('Por favor completa todos los campos');
      return;
    }

    if (password !== confirmPassword) {
      toast.error('Las contraseñas no coinciden');
      return;
    }

    if (password.length < 6) {
      toast.error('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    try {
      setLoading(true);
      await register(name, email, password);
      toast.success('¡Cuenta creada exitosamente!');
      navigate('/');
    } catch (error) {
      const message = error.response?.data?.detail || 'Error al crear cuenta';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-20 min-h-screen bg-[#FAFAF9] flex items-center justify-center" data-testid="register-page">
      <div className="w-full max-w-md px-6 py-16">
        <div className="text-center mb-12">
          <Link to="/">
            <h1 
              className="text-4xl font-light tracking-tight text-[#1C1917] mb-2"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Aliglam
            </h1>
          </Link>
          <p className="text-[#A8A29E]">Crear una cuenta nueva</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-testid="register-form">
          <div>
            <label className="block text-sm text-[#57534E] mb-2">
              Nombre completo
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-3 rounded-xl border border-[#E7E5E4] focus:outline-none focus:border-[#BA7B7C] transition-colors"
              placeholder="Tu nombre"
              data-testid="name-input"
            />
          </div>

          <div>
            <label className="block text-sm text-[#57534E] mb-2">
              Correo electrónico
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 rounded-xl border border-[#E7E5E4] focus:outline-none focus:border-[#BA7B7C] transition-colors"
              placeholder="tu@email.com"
              data-testid="email-input"
            />
          </div>

          <div>
            <label className="block text-sm text-[#57534E] mb-2">
              Contraseña
            </label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-[#E7E5E4] focus:outline-none focus:border-[#BA7B7C] transition-colors pr-12"
                placeholder="••••••••"
                data-testid="password-input"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-[#A8A29E] hover:text-[#57534E]"
              >
                {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
              </button>
            </div>
          </div>

          <div>
            <label className="block text-sm text-[#57534E] mb-2">
              Confirmar contraseña
            </label>
            <input
              type={showPassword ? 'text' : 'password'}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-xl border border-[#E7E5E4] focus:outline-none focus:border-[#BA7B7C] transition-colors"
              placeholder="••••••••"
              data-testid="confirm-password-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full"
            data-testid="register-submit"
          >
            {loading ? 'Creando cuenta...' : 'Crear cuenta'}
          </button>
        </form>

        <p className="text-center text-[#57534E] mt-8">
          ¿Ya tienes cuenta?{' '}
          <Link to="/login" className="text-[#BA7B7C] hover:text-[#A36566] transition-colors">
            Iniciar sesión
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
